module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/gasred.json
// module id = 349
// module chunks = 93454751428311